<app-navbar></app-navbar>
<router-outlet></router-outlet>
<!--<app-newsletter></app-newsletter>-->
<app-footer></app-footer>
<ngx-scrolltop></ngx-scrolltop>
